import React from "react";
import { IResourceComponentsProps, BaseRecord } from "@refinedev/core";
import Cw8List from "components/cw8/Cw8List";

export const FragmentTypesList: React.FC<IResourceComponentsProps> = () => {

    const resourceName :string = "fragmentType";
    return (
        <Cw8List
            resourceName = {resourceName}
        ></Cw8List>
    );
};
